import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'age', 'restingHr', 'maxHr', 'fitnessLevel',
    'zone2Low', 'zone2High', 'maxHrDisplay', 'hrReserve',
    'weeklyMinutes', 'weeklyMinutesMax'
  ]

  connect() {
    this.calculate()
  }

  calculate() {
    const age = parseInt(this.ageTarget.value, 10) || 35
    const restingHr = parseInt(this.restingHrTarget.value, 10) || 60
    const inputMaxHr = parseInt(this.maxHrTarget.value, 10)
    const fitnessLevel = this.fitnessLevelTarget.value

    // Calculate max HR using Tanaka formula if not provided
    const maxHr = inputMaxHr || Math.round(208 - (0.7 * age))
    const hrReserve = maxHr - restingHr

    this.maxHrDisplayTarget.textContent = maxHr
    this.hrReserveTarget.textContent = hrReserve

    // Zone 2 using Karvonen (60-70% of HRR)
    // Adjust slightly based on fitness level
    let zone2LowPct = 0.60
    let zone2HighPct = 0.70

    if (fitnessLevel === 'beginner') {
      zone2LowPct = 0.55
      zone2HighPct = 0.65
    } else if (fitnessLevel === 'advanced') {
      zone2LowPct = 0.65
      zone2HighPct = 0.75
    }

    const zone2Low = Math.round((hrReserve * zone2LowPct) + restingHr)
    const zone2High = Math.round((hrReserve * zone2HighPct) + restingHr)

    this.zone2LowTarget.textContent = zone2Low
    this.zone2HighTarget.textContent = zone2High

    // Weekly recommendations based on fitness level
    let weeklyMin; let
      weeklyMax
    if (fitnessLevel === 'beginner') {
      weeklyMin = 120
      weeklyMax = 150
    } else if (fitnessLevel === 'advanced') {
      weeklyMin = 180
      weeklyMax = 300
    } else {
      weeklyMin = 150
      weeklyMax = 180
    }

    this.weeklyMinutesTarget.textContent = weeklyMin
    this.weeklyMinutesMaxTarget.textContent = weeklyMax
  }
}
